const BASE_URL = (process.env.REACT_APP_BOOKS_LAMBDA_URL || "").replace(/\/$/, "");
const API_KEY = process.env.REACT_APP_BOOKS_API_KEY || "";
const TOKEN_KEY = "tbr_token";

export const TBR_USERS = [
    { name: "Jemma",   initial: "J", color: "red",    classification: "TBR.001.JM" },
    { name: "Jordyn",  initial: "J", color: "blue",   classification: "TBR.002.JR" },
    { name: "Jaimie",  initial: "J", color: "green",  classification: "TBR.003.JA" },
    { name: "Jessica", initial: "J", color: "purple", classification: "TBR.004.JS" },
    { name: "Kim",     initial: "K", color: "amber",  classification: "TBR.005.KM" },
    { name: "Matthew", initial: "M", color: "gray",   classification: "TBR.006.MT", admin: true },
];

export function getStoredToken() {
    return localStorage.getItem(TOKEN_KEY);
}

export function storeToken(t) {
    localStorage.setItem(TOKEN_KEY, t);
}

export function clearToken() {
    localStorage.removeItem(TOKEN_KEY);
}

export function decodeToken(token) {
    try {
        const b64 = token.split(".")[1].replace(/-/g, "+").replace(/_/g, "/");
        const payload = JSON.parse(atob(b64));
        if (payload.exp && Date.now() / 1000 > payload.exp) return null;
        if (payload.type !== "tbr") return null;
        return payload;
    } catch {
        return null;
    }
}

async function request(method, path, body, token) {
    const headers = {
        "Content-Type": "application/json",
        "X-Api-Key": API_KEY,
    };
    if (token) headers["Authorization"] = `Bearer ${token}`;

    const res = await fetch(`${BASE_URL}${path}`, {
        method,
        headers,
        body: body !== undefined ? JSON.stringify(body) : undefined,
    });

    if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        const error = new Error(err.message || "Request failed");
        error.status = res.status;
        throw error;
    }
    return res.json();
}

export async function login(name, dob) {
    const data = await request("POST", "/tbr/auth", { name, dob });
    storeToken(data.token);
    return data;
}

export async function fetchLists(token) {
    return request("GET", "/tbr/lists", undefined, token);
}

export async function addBook(token, entry) {
    return request("POST", "/tbr/books", entry, token);
}

export async function deleteBook(token, id) {
    return request("DELETE", `/tbr/books/${id}`, undefined, token);
}

export async function togglePurchase(token, id, seriesIndex) {
    const body = typeof seriesIndex === "number" ? { seriesIndex } : {};
    return request("PATCH", `/tbr/books/${id}/purchase`, body, token);
}

export async function fetchUserQuote(token) {
    return request("GET", "/tbr/user-quote", undefined, token);
}

export async function updateBook(token, id, payload) {
    return request("PUT", `/tbr/books/${id}`, payload, token);
}

export async function convertToSeries(token, id, payload) {
    return request("POST", `/tbr/books/${id}/convert-to-series`, payload, token);
}

export async function addSeriesBook(token, id, title) {
    return request("POST", `/tbr/books/${id}/series-books`, { title }, token);
}

export async function reorderBooks(token, ids, targetUser) {
    const body = targetUser ? { ids, targetUser } : { ids };
    return request("PATCH", "/tbr/order", body, token);
}

export async function updateSelfStatus(token, id, status, seriesIndex) {
    const body = typeof seriesIndex === "number" ? { status, seriesIndex } : { status };
    return request("PATCH", `/tbr/books/${id}/self-status`, body, token);
}

// Book Club
export async function fetchBookClub(token) {
    return request("GET", "/tbr/bookclub", undefined, token);
}
export async function patchMeeting(token, date, location) {
    return request("PATCH", "/tbr/bookclub/meeting", { date, location }, token);
}
export async function patchCurrentBook(token, book) {
    return request("PATCH", "/tbr/bookclub/current", book, token);
}
export async function startNewBook(token, wasFinished) {
    return request("POST", "/tbr/bookclub/new-book", { wasFinished }, token);
}
export async function submitRating(token, stars, comment, skip) {
    return request("POST", "/tbr/bookclub/rate", { stars, comment, skip }, token);
}
export async function submitNomination(token, book, skip) {
    return request("POST", "/tbr/bookclub/nominate", skip ? { skip: true } : book, token);
}
export async function submitRunoffVote(token, nominationIndex) {
    return request("POST", "/tbr/bookclub/runoff-vote", { nominationIndex }, token);
}
export async function confirmWinner(token) {
    return request("POST", "/tbr/bookclub/confirm-winner", {}, token);
}
export async function forceEndVote(token) {
    return request("POST", "/tbr/bookclub/force-end", {}, token);
}
